// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/style-loader!./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-ae893b46&scoped=true!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pageview/web/speed.vue
// module id = 588
// module chunks = 0